import ActivationPage from 'components/activation/activation-page.component';
import PasswordlessActivationPage from 'pages/passwordless-activation/passwordless-activation.component';
import ResetPassword from 'pages/reset-password/reset-password.component';
import VerifySms from 'pages/verify-sms/verify-sms.component';
import { Route } from 'react-router';

const AuthRoutes = () => [
  <Route path="/auth/resetpassword" component={ResetPassword} />,
  <Route path="/auth/verifyEmail" component={ActivationPage} />,
  <Route path="/auth/verifySms" component={VerifySms} />,
  <Route path="/m-login" component={PasswordlessActivationPage} />,
];

export default AuthRoutes;
